"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red = {
  10: '#FEEEEF',
  20: '#FEDCDF',
  30: '#FDCBCF',
  40: '#FDB9BF',
  50: '#FCA8AF',
  60: '#FB979F',
  70: '#FB858F',
  80: '#FA747F',
  90: '#FA626F'
};
var yellow = {
  10: '#FFFAE5',
  20: '#FFF6CC',
  30: '#FFF1B2',
  40: '#FFEC99',
  50: '#FFE780',
  60: '#FFE366',
  70: '#FFDE4C',
  80: '#FFD933',
  90: '#FFD519'
};
var blue = {
  10: '#E5ECFA',
  20: '#CCDAF6',
  30: '#B2C7F1',
  40: '#99B5ED',
  50: '#80A2E8',
  60: '#6690E3',
  70: '#4C7DDF',
  80: '#336BDA',
  90: '#1958D6'
};
var blueLight = {
  50: '#F2F6FD'
};
var black = {
  10: '#E8E9EA',
  20: '#D1D3D5',
  30: '#BABDC0',
  40: '#A3A7AB',
  50: '#8C9196',
  60: '#757B81',
  70: '#5E656C',
  80: '#474F57',
  90: '#303942'
};
exports.colors = {
  red: exports.red,
  yellow: yellow,
  blue: blue,
  blueLight: blueLight,
  black: black
};
exports.default = exports.colors;